module.exports = __webpack_public_path__ + "static/media/hall-P12.4dfc2e6b.svg";